import Link from 'next/link';
import { Icon, IconType } from '../icons';
import { INavbarProps } from 'types';

export const Navbar = (props?: INavbarProps) => {
  return (
    <nav className="w-full border-y-[1px] border-solid border-neutralGrey bg-lightGrey">
      <div className="mx-auto flex max-w-7xl items-center justify-center py-4">
        <Link href={props?.url || '/'}>
          <Icon icon={IconType.BOSFull} width={120} height={24} />
        </Link>
      </div>
    </nav>
  );
};
